module.exports = __webpack_public_path__ + "img/SketchPng48d950e08e37b0a10131865fc7f6f15986e6048111dac34d684231ecca456a72.296bc135.png";